var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layer-group',{ref:"lgroup",attrs:{"name":_vm.name,"visible":_vm.visible,"layer-type":"base"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }